import mainCaller from './mainCaller';

// 구독제 이용권(COURSE_PASS) 해지 API — 약정/위약금 없음.
// 해지 = 정기결제만 중지(billing CANCELLED), 이용권은 만료일(expireDate)까지 유지.
// passType: 'COURSE_PASS', passId: 회원 구매분 id (memberCoursePassId)

/**
 * 지점의 구독 기능 승인 여부를 조회한다.
 * @param {number|string} branchId - 지점 ID
 * @param {string} token - 인증 토큰
 * @returns {Promise<{ enabled: boolean }>}
 */
export async function getBranchSubscriptionEligibility(branchId, token) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/subscription-eligibility`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 해지 미리보기 (영속하지 않음) — {passId, expireDate, billingStatus, passStatus}
export async function previewSubscriptionCancellation(passType, passId, token) {
  return await mainCaller(`admin/api/v1/subscriptions/${passType}/${passId}/cancellation/preview`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 구독 해지: 정기결제만 중지. 이용권은 만료일까지 유지(즉시 박탈 아님).
export async function cancelSubscription(passType, passId, token) {
  return await mainCaller(`admin/api/v1/subscriptions/${passType}/${passId}/cancellation`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 구독 변경/청구 이력 (분쟁·CS 대응) — [{occurredAt, event, success, amount, billingDate, message, actorType, actorId}]
export async function getSubscriptionLogs(passType, passId, token) {
  return await mainCaller(`admin/api/v1/subscriptions/${passType}/${passId}/logs`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
}

